export async function postVisit(target?: string) {
    try {
        await fetch('/api/traffic/visit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ target })
        });
    }
    catch (e) {
        // non-blocking
        console.debug('postVisit failed', e);
    }
}
